import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography'; 

const formQuestionTextStyle=theme=>({
    root: theme.mixins.gutters({
        paddingTop: 5,
        paddingBottom: 5,
        marginTop: theme.spacing.unit * 1
    })
})

let FormQuestionText=props=>{
    const { classes,questionText,questionId,...other } = props;
    return (
        <div>
            <Paper className={classes.root} elevation={4}>
                <Typography component='p'>
                    {questionText} 
                </Typography> 
                <Typography variant="caption" gutterBottom>
                    Question Ref. Id: {questionId}
                </Typography>   
            </Paper>    
        </div>    
    )
}

FormQuestionText.propTypes = {
    classes: PropTypes.object.isRequired,
    questionText: PropTypes.string.isRequired
}

export default withStyles(formQuestionTextStyle)(FormQuestionText)


// WEBPACK FOOTER //
// ./src/views/ProjectGorgon/common/FormQuestionText.js